import styled from 'styled-components';
import { Tooltip, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = ({
  children,
  schema,
  ...rest
}) => /*#__PURE__*/_jsx(Tooltip, {
  closeOnOutsideClick: false,
  content: schema.label,
  placement: "top-start",
  size: "s",
  variant: "inverted",
  "data-sentry-element": "Tooltip",
  "data-sentry-component": "Wrapper",
  "data-sentry-source-file": "limitSummaryElements.tsx",
  children: ({
    ref,
    open,
    close
  }) => /*#__PURE__*/_jsx("div", {
    onMouseEnter: open,
    onMouseLeave: close,
    ...rest,
    ref: ref,
    children: children
  })
});
export const LimitSummaryContainer = styled(Wrapper).withConfig({
  displayName: "limitSummaryElements__LimitSummaryContainer"
})(["cursor:default;width:", ";white-space:nowrap;", ";"], tombac.unit(24), tombac.text({
  color: tombac.color('neutral', 700),
  fontSize: 12
}));
export const LimitSummaryIcon = styled.div.withConfig({
  displayName: "limitSummaryElements__LimitSummaryIcon"
})(["font-size:1rem;vertical-align:-0.5rem;"]);
export const LimitSummaryLimit = styled.span.withConfig({
  displayName: "limitSummaryElements__LimitSummaryLimit"
})(["padding-left:", ";"], tombac.space(0.5));
export const LimitSummaryUsage = styled.span.withConfig({
  displayName: "limitSummaryElements__LimitSummaryUsage"
})(["color:", ";font-size:12px;margin-left:4px;"], ({
  danger
}) => tombac.parse(danger ? '--danger-500' : '--success-800'));